import { useAPI } from "~/uses/useMyFetch";
import { Product } from "~/models/product.model";
import { useProductFilterStore } from "~/store/productFilter.store.js";
import { productFilterConfig } from "~/config/productFilter.config.js";

export const useProductStore = defineStore("productStore", {
  state: () => {
    return {
      products: null,
      totalItems: null,
    };
  },
  actions: {
    async fetch() {
      await useAPI("/catalog/product/list/all", {
        params: this.buildRequestParams(),
        lazy: true,
      }).then((data) => {
        this.totalItems = data.totalItems;
        this.products = this.dtoTransform(data.items);
      });
    },
    async getMoreProducts(pageNum) {
      await useAPI("/catalog/product/list/all", {
        params: {
          ...this.buildRequestParams(),
          pageNum: pageNum,
        },
      }).then((data) => {
        this.products = [...this.products, ...this.dtoTransform(data.items)];
      });
    },
    dtoTransform(dto) {
      return dto.map((item) => new Product(item));
    },
    buildRequestParams() {
      const requestParams = {};

      for (const [paramKey, paramValue] of Object.entries(
        useProductFilterStore().params,
      )) {
        requestParams[
          productFilterConfig[paramKey].request?.alias ?? paramKey
        ] =
          productFilterConfig[paramKey].request?.encode(paramValue) ??
          productFilterConfig[paramKey].state.encode(paramValue);
      }

      return requestParams;
    },
  },
});
